import theme from '../../../lib/theme';
import { VideoProps } from './Video';

const { scale, media, font, colors } = theme;

export const videoFrameStyles = () => ({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,

    [media.xxs.up]: {
      bottom: 0,
      right: 0,
      width: '100%',
      height: '100%',
    },
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});

export default ({ bg_url }: VideoProps) => ({
  container: {
    width: '100%',
    paddingBottom: '56.25%',
    position: 'relative',
    overflow: 'hidden',
  },
  bg: {
    backgroundImage: `url('${bg_url}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  },
  caption: {
    padding: `${scale.xxs} 0`,
    color: colors.black,
    fontSize: font.s,
    lineHeight: font.heights.s,
    fontWeight: font.normal,
    letterSpacing: font.spacings.m
  },
});
